export const toTitleCase = (str: string | undefined): string => {
  return str !== undefined
    ? str.replace(/\S+/g, (str) => str.charAt(0).toUpperCase() + str.substr(1).toLowerCase())
    : '';
};
